// extracted by mini-css-extract-plugin
export default {"profile__pic":"photo_profile__pic__bsKcc","profile__file":"photo_profile__file__rTWfI","profile__box":"photo_profile__box__svUrh"};